import { render, staticRenderFns } from "./PortalInfo.vue?vue&type=template&id=2beb56ca&scoped=true&"
import script from "./PortalInfo.vue?vue&type=script&lang=js&"
export * from "./PortalInfo.vue?vue&type=script&lang=js&"
import style0 from "./PortalInfo.vue?vue&type=style&index=0&id=2beb56ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beb56ca",
  null
  
)

export default component.exports